import React from 'react';
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export type severityType = "success" | "info" | "warning" | "error";

export interface CustomSnackbarProps {
  open: boolean;
  severity: severityType
  message: string;
  handleClose: () => void;
}

export const CustomSnackbar: React.FC<CustomSnackbarProps> = ({ open, severity, message, handleClose }) => {
  const getBackgroundColor = (severity: "success" | "info" | "warning" | "error") => {
    switch (severity) {
      case 'success':
        return '#E9775F'; // Laranja
      case 'error':
        return '#D32F2F'; // Vermelho
      case 'warning':
        return '#FFA000'; // Amarelo
      case 'info':
        return '#1976D2'; // Azul
      default:
        return undefined;
    }
  };

  return (
    <Snackbar open={open} autoHideDuration={3100} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <Alert 
        onClose={handleClose} 
        severity={severity}
        sx={{
          backgroundColor: getBackgroundColor(severity),
          '& .MuiAlert-action button': {
            width: '1.2rem !important',
            height: '1.2rem !important',
            top: '0.25rem',
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
